import { User } from "../@core/data/users";

export default class LectureContent {
  id?: string;
  courseId?: string;
  sectionId?: string;
  lectureId?: string;
  quizId?: string;
  refTitle?: string;

  title?: string;
  description?: string;
  coverUrl?: string;

  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images

  tags?: string[];
  privacy?: boolean;
  status?: number;
  showComments?: boolean;
  newComment?: boolean;

  noViewer?: number;
  noLiked?: number;
  noComment?: number;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
